<template>
    <modal @close="closeModal">
        <div role="alert" dusk="alert" class="alert alert--danger" v-if="showError">
            {{ trans('domain.dnssec.errors.enable') }}
        </div>

        <h1 class="modal__title">Domain DNSSEC</h1>
        <form @submit.prevent="updateDnssecKey">
            <div class="layout">
                <div class="layout__item u-2/5-desk">
                    <single-select
                        dusk="country-component"
                        v-model="form.flags"
                        :error="form.errors.first('flags')"
                        :label="trans('domain.dnssec.form.flags')"
                        :options="flags"
                        optionLabel="flagName"
                        optionValue="flagId"
                        name="flags"
                        class="select--flags u-full-width"
                        required
                    />
                </div>
                <div class="layout__item u-3/5-desk">
                    <single-select
                        dusk="country-component"
                        v-model="form.alg"
                        :error="form.errors.first('alg')"
                        :label="trans('domain.dnssec.form.alg')"
                        :options="alg"
                        optionLabel="algName"
                        optionValue="algId"
                        name="alg"
                        class="select--alg u-full-width"
                        required
                    />
                </div>
            </div>
            <!-- -->
            <div class="layout | u-margin-bottom">
                <div class="layout__item u-1/2-desk">
                    <div class="field u-full-width">
                        <label class="field__label">{{ trans('domain.dnssec.form.pubKey') }}</label>
                        <br />
                        <textarea v-model="form.pubKey" class="field | u-padding-narrow" rows="15" cols="69"></textarea>
                    </div>
                </div>
            </div>

            <div class="modal__nav">
                <button class="btn btn--blue-record btn-ghost--dns" dusk="confirm-button" type="submit">
                    {{ trans('action.set') }}
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import { Modal } from 'relapp-modal';
import { Way2Form } from 'relapp-way2forms';
import { EventBus } from 'relapp-event';
import { DnssecApi } from 'relapp-technical-management';

export default {
    components: {
        Modal
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        dnssecKeys: {
            type: Array,
            default: () => []
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                flags: 257,
                alg: 13,
                pubKey: ''
            }),
            flags: [
                {
                    flagId: 256,
                    flagName: 'ZSK (256)'
                },
                {
                    flagId: 257,
                    flagName: 'KSK (257)'
                }
            ],
            alg: [
                {
                    algId: 8,
                    algName: 'RSA/SHA-256 (8)'
                },
                {
                    algId: 13,
                    algName: 'ECDSA Curve P-256 with SHA-256 (13)'
                }
            ],
            showError: false
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        if (this.dnssecKeys.length > 0) {
            this.form.flags = this.dnssecKeys[0].flags;
            this.form.alg = this.dnssecKeys[0].alg;
            this.form.pubKey = this.dnssecKeys[0].pubKey;
        }
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');

            // Refresh
            DnssecApi.get(this.routeParams);
        },

        /**
         * Updated DNSSEC key.
         */
        updateDnssecKey() {
            DnssecApi.enableWithKey(this.domain, this.form.data())
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });

                    // Refresh
                    DnssecApi.get(this.routeParams);

                    this.$emit('close');
                })
                .catch(error => {
                    this.showError = true;
                });
        }
    }
};
</script>
